<template>
  <div v-if="tpl==='default'" class="f">
    <div class="card w-80">
      <div class="card bg-base-100 image-full  shadow-xl m-3" @click="openSheet">
        <figure>
          <NuxtImg :src="record.picture.cropped.fileUrl" :alt="record.name" width="300" quality="60" format="webp" />
        </figure>
        <div class="card-body p-3">
          <div class="badge badge-success text-white">{{ record.causes }}</div>

          <!--<p>{{record.proposition_value}}</p>-->
        </div>
      </div>
      <h2 class="m-3 text-gray-700">{{ record.name }}</h2>
    </div>

  </div>
  <div v-if="tpl==='light'">
    <button class="card bg-base-100 w-96 shadow-xl m-3" @click="openSheet">
      <div class="card-body p-3">
        <div class="flex justify-between gap-3 items-center">
          <div class="flex flex-row gap-3 items-center">
            <div class="avatar">
              <div class="w-16 rounded-full">
                <NuxtImg :src="record.logo.cropped.fileUrl" :alt="record.name" width="300" quality="60" format="webp" />
              </div>
            </div>
            <div class="text-gray-700">{{ record.name }}</div>
          </div>

          <div class="">
            <div class="rounded-full"><span class="sa sa-arrow-right-up linear"></span></div>
          </div>
        </div>
      </div>
    </button>
  </div>
</template>
<script lang="ts" setup>
import {type ONPRecord} from "~/types/record";
const emit = defineEmits(['record:open']);
const props = defineProps({
  record: {
    type: {} as PropType<ONPRecord>
  },
  tpl: {
    type: String,
    default: 'default'
  }
});
const openSheet = () => {
  emit('record:open', props.record);
}
</script>
<style scoped>
.card.image-full:before {
  background-color: transparent;
}
.card{
  @apply cursor-pointer
}
</style>